
export function sortDrugList( data, key ){

    function compareByForm(e1, e2) {
        if(e1.drugForm < e2.drugForm) return -1
        return 1
    }
    function checkIsNaN(value) {
       return isNaN(value) ? 0 : value
    }
    function compareByStrength(e1, e2){

        const strengthNumbersRegex = /[0-9]+/g
        const e1Numbers = e1.drugStrength.match(strengthNumbersRegex)
        const e2Numbers = e2.drugStrength.match(strengthNumbersRegex)
        const e1Value = checkIsNaN(parseInt(e1Numbers[0]))
        const e2Value = checkIsNaN(parseInt(e2Numbers[0]))

        if (e1Value < e2Value) return -1
        else if( e1Value === e2Value ) return 0
        return 1
    }

    if(key === 'form'){
        data.sort(compareByForm)
    }
    else if(key === 'strength'){
        // data.sort(compareByStrength)
    }
}